import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/UserTransaction`;


const ApiUserTransaction = {

  getAllUserTransaction: (params) => {
    const url = `${baseServiceUrl}/getAllUserTransaction?PageNumber=${params.pageNumber}&PageSize=${params.pageSize}&globalSearch=${params.globalSearch}`;

    return ServiceApi.get(url, params);
  },

};

export default ApiUserTransaction;